import { defineMessages } from 'react-intl';

export default defineMessages({
  lookbackPeriodFilterAriaLabel: {
    description: 'Aria label for lookback period filter',
    defaultMessage: 'Lookback period filter',
    id: 'YX3GEh',
  },
  forecastPeriodFilterAriaLabel: {
    description: 'Aria label for forecast period filter',
    defaultMessage: 'Forecast period filter',
    id: 'y1IHbv',
  },
  salesTrendModifierAriaLabel: {
    description: 'Aria label for sales trend modifier',
    defaultMessage: 'Sales trend modifier',
    id: 'YjGtkt',
  },
  leadTimeModifierAriaLabel: {
    description: 'Aria label for lead time modifier',
    defaultMessage: 'Lead time modifier',
    id: 'iaIkYZ',
  },
  bufferStockModifierAriaLabel: {
    description: 'Aria label for buffer stock modifier',
    defaultMessage: 'Buffer stock modifier',
    id: 'cJG6xu',
  },
  lookbackPeriodPlaceholder: {
    description: 'Placeholder text for lookback period dropdown',
    defaultMessage: 'Select lookback period',
    id: 'oYJX95',
  },
  forecastPeriodPlaceholder: {
    description: 'Placeholder text for forecast period dropdown',
    defaultMessage: 'Select forecast period',
    id: 'GdPHJ8',
  },
});
